import React, { Fragment, PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Loader } from "semantic-ui-react";

import ChargeFromEstimate from "../projectWizard/estimatePanel/ChargeFromEstimate";

class ImageEstimate extends PureComponent {
  static propTypes = {
    estimate: PropTypes.object,
    isFetching: PropTypes.bool.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    isFetching: false,
    copyKey: "image"
  };

  render() {
    const { estimate, isFetching, copyKey, copy } = this.props;

    return (
      <Fragment>
        <p className="small-text">
          {copy(`${copyKey}.estimate.description`)}
          <br />
          {isFetching && <Loader as="span" active inline size="tiny" />}
          <b>
            <ChargeFromEstimate
              estimate={estimate}
              resourceKey="images"
              dimension="weekly"
            />
          </b>
        </p>
      </Fragment>
    );
  }
}

export default ImageEstimate;
